import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueKeycloak from '@dsb-norge/vue-keycloak-js'
import type { VueKeycloakInstance, VueKeycloakOptions } from '@dsb-norge/vue-keycloak-js'
import App from './App.vue'
import router from './router'
import { useAuthStore } from "./stores/auth";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import i18n from './i18n/index'
import 'sweetalert2/dist/sweetalert2.min.css'
import OpenLayersMap, { Styles } from 'vue3-openlayers'
import 'vue3-openlayers/dist/vue3-openlayers.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

const options: VueKeycloakOptions = {
  config: {
    url: import.meta.env.VITE_SSO_URL,
    realm: import.meta.env.VITE_SSO_REALM,
    clientId: import.meta.env.VITE_SSO_CLIENT_ID,
  },
  init: {
    onLoad: 'check-sso',
    pkceMethod: 'S256',
    checkLoginIframe: false,
    enableLogging: true
  },
  logout: {
    redirectUri: window.location.origin,
  },
  onReady(keycloak: any, keycloakInstance?: VueKeycloakInstance) {
    console.log("onReady  " + keycloak.authServerUrl + " " + keycloak.realm + " " + keycloak.clientId)
    if (keycloakInstance) {
      useAuthStore().setKeycloak(keycloakInstance)
      app.config.globalProperties.$keycloak = keycloakInstance
      console.log("onReady  authenticated: " + keycloakInstance.authenticated + " " + keycloakInstance.tokenParsed)
    }
  },
  onInitSuccess() {
    console.log("onInitSuccess")
  },
  onAuthLogout() {
    console.log("onAuthLogout")
  },
  onAuthRefreshError() {
    console.log("onAuthRefreshError")
  },
  onAuthRefreshSuccess() {
    console.log("onAuthRefreshSuccess")
    useAuthStore().setLastReset(new Date())
  },
  onInitError(error: any, err: any) {
    console.log("Keycloak init error", error, err)
  },
}

app.use(VueKeycloak, options)
app.use(router)
app.use(ElementPlus)
app.use(i18n)
app.use(OpenLayersMap)
app.use(Styles)
app.mount('#app')

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $keycloak: VueKeycloakInstance
  }
}

export {}
